import { WORKFLOWS_GET_WORKFLOW_PER_FOLDER_API } from "Constant/api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { authService } from "Service/Axios";

export const useFormListWorkflow = (payload) => {
    const [formList, setFormList] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchFormList = async () => {
        setLoading(true);
        try {
            const response = await authService(
                WORKFLOWS_GET_WORKFLOW_PER_FOLDER_API,
                "POST",
                payload
            );
            setFormList(response);
        } catch (error) {
            toast.error("Error fetching form list:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (
            payload.archive ||
            payload.favorite ||
            payload.folderId ||
            payload.recyleBin ||
            payload.template
        ) {
            fetchFormList();
        }
    }, [payload]);

    return { formList, setFormList, fetchFormList, loading };
};